import React, { createContext, useContext, useState } from 'react';

const LoginContext = createContext();

export const useLogin = () => {
  const context = useContext(LoginContext);
  if (!context) {
    throw new Error('useLogin must be used within a LoginProvider');
  }
  return context;
};

export const LoginProvider = ({ children }) => {
  const [openAuth, setOpenAuth] = useState(false);
  const [authMode, setAuthMode] = useState("signin");
  const [pendingDest, setPendingDest] = useState(null);

  return (
    <LoginContext.Provider value={{
      openAuth,
      setOpenAuth,
      authMode,
      setAuthMode,
      pendingDest,
      setPendingDest
    }}>
      {children}
    </LoginContext.Provider>
  );
};
